<template>
  <div
    class="bottom-0 py-3 min-w-full bg-white border-t border-cool-gray-200 dark:border-cool-gray-50 dark:bg-surface-800">
    <div class="flex justify-between items-center px-6 mx-auto">
      <div class="flex flex-1 text-sm font-normal text-gray-500 transition-colors duration-150 dark:text-gray-100">
        Propulsé par OCV {{ version }} &copy; {{ year }} Groupe Dadoun
      </div>
      <div class="flex flex-shrink-0 items-center">
        <div class="text-center md:flex">
          <a
            href="#"
            class="inline-flex relative items-center py-1 px-2 text-xs font-medium text-white bg-indigo-600 rounded-md border border-transparent shadow-sm hover:bg-indigo-700 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-none">Besoin
            d'aide ?</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
const year = new Date().getFullYear();
const config = useRuntimeConfig();
const version = config.public.appVersion;
</script>
